/**
 * Get enum field
 * @private
 * @param {Object} attrs - enum property define
 * @returns {Object} - field define with property control and values
 */
export function enumField(attrs) {
  return {
    // for enum property, default view is select
    control: 'select',
    // options are all enum values
    values: attrs.enum,
  };
}
